
import { getChatStatus, isLoggedIn, showLoginModal } from '../utils';
import React, { useEffect, useRef, useState } from 'react'

function ContactPage() {
    useEffect(() => {



    }, [])
    let [loggedIN, setLogged] = useState(isLoggedIn());
    useEffect(() => { setLogged(isLoggedIn()) }, [isLoggedIn()])
    const creaRef = useRef(null);

    const [chatStatus, setChatStatus] = useState(getChatStatus())
    useEffect(() => {
        window.addEventListener('showChat', () => {
            setChatStatus(getChatStatus())
        })
    }, [])
    return (
        <div className={`${chatStatus == false ? 'page-container' : 'page-container open-chat'}`}>
            <p style={{ fontSize: '28px', color: '#fff', fontWeight: 'bold', marginBottom: '10px' }}>Contact</p>



            <p style={{ fontSize: '13px', color: 'var(--text-primary)', textAlign: 'left', marginBottom: '20px' }}>Don't hesitate to get in contact with us, for support or business, and we'll get back to you within 72 working hours!</p>
            <p style={{ fontSize: '13px', color: 'var(--text-primary)', textAlign: 'left', marginBottom: '20px' }}>For every support inquiry, please contact the
                <p onClick={() => {
                    if (loggedIN == false) {
                        showLoginModal();
                    } else {
                        
                    }
                }} style={{ fontSize: '13px', color: 'var(--brand)', display: 'inline', cursor: 'pointer', fontWeight: 'bold' }}> Live Support chat.</p></p>
            <p style={{ fontSize: '13px', color: 'var(--text-primary)', textAlign: 'left', marginBottom: '20px' }}>
                Business inquiries:

                <a href="mailto:hello@paidcash.co?Subject=Business Inquiry" style={{ fontSize: '13px', color: 'var(--brand)', display: 'inline', cursor: 'pointer', fontWeight: 'bold' }}> hello@paidcash.co</a> (No Support)</p>
            <p style={{ fontSize: '13px', color: 'var(--text-secondary)', display: 'inline', cursor: 'pointer', fontWeight: 'bold' }}> Support inquiries sent to the mention email address won't get responded. Support inquiries can only be done through the Live Support chat.</p>
        </div>
    )
}

export default ContactPage